<template>
  <b-modal id="special-discount-rejected-modal" dialog-class="base-modal" :title="title" centered footer-class="mt-3 "
    title-class="position-relative">
    <p class="text-center px-md-5">{{ message }}</p>
    <template #modal-footer>
      <b-button pill variant="outline-secondary" class="mx-2"
        @click="closeModal">Close</b-button>
      <b-button variant="primary" pill class="mx-2" @click="goToLanding">Back to Ordering</b-button>
    </template>
  </b-modal>
</template>

<script>
import _ from "lodash";

export default {
  name: "SpecialDiscountRejectedModal",
  props: {
    idType: {
      type: String,
      default: "Senior Citizen"
    }
  },
  data() {
    return {
      title: "Your order has been cancelled",
      message: `The ${this.idType} ID discount was not approved. Please add your items to the cart again to place a new order.`
    }
  },
  computed: {
    pastOrder() {
      return _.get((this.$store.state.estore.orders || []).pop(), "orders", [])[0] || {};
    }
  },
  methods: {
    closeModal() {
      this.$bvModal.hide('special-discount-rejected-modal')
    },
    goToLanding() {
      const { branch_uuid, brand_uuid } = this.pastOrder;
      if (branch_uuid && brand_uuid) {
        this.$router.push({ name: "Store", params: { id: `${branch_uuid}&${brand_uuid}` } });
        this.closeModal();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#special-discount-rejected-modal {
  .modal-footer {
    justify-content: space-evenly;

    &>.btn {
      width: calc(50% - 0.5rem * 2);
      height: 50px;
      font-size: 16px;
    }
  }
}
</style>

<style lang="scss">
#special-discount-rejected-modal {
  .modal-title {
    font-size: 24px;
    top: 20px;
  }
}
</style>
